import React, { FC } from 'react';

import { useTeamNameMutation } from '../../api/team-name-admin';
import * as CSS from './team-name-styles';
import { Team, UpdateStatus } from '../../../database.schema';

type UpdateButtonProps = {
  team: string;
  teamDetails: Team;
  tournamentIndex: number;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
  disabled: boolean;
};

export const UpdateButton: FC<UpdateButtonProps> = ({ team, teamDetails, tournamentIndex, setUpdateStatus, disabled }) => {
  const mutation = useTeamNameMutation();
  const saveCourse = () => {
    mutation.mutate(
      { tournamentIndex, team, teamDetails },
      {
        onSuccess: (data) => {
          setUpdateStatus({ success: true, error: false });
        },
        onError: (error) => {
          setUpdateStatus({ success: false, error: true });
        },
      }
    );
  };
  return (
    <CSS.ButtonWrapper>
      <CSS.Button data-testid={`${team}-save-button`} onClick={() => saveCourse()} disabled={disabled}>
        Save
      </CSS.Button>
    </CSS.ButtonWrapper>
  );
};
